<template>
<div class="k-page-content">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="分类管理" name="first">
                <div class="k-page-common">
                    <!-- <div class="k-common-header">
                        <div class="k-filter-option k-filter-input" style="margin-bottom:0;">
                            <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
                                <el-form-item label="分类名称">
                                    <el-input v-model="searchForm.name" placeholder="请填写分类名称" clearable></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
                                    <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div> -->
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="k-table-toolbar" style="margin-top:0;">
                                <div>
                                    <el-button type="primary" size="mini" @click="addFlowtypeOpen">添加分类</el-button>
                                </div>
                            </div>
                            <div class="k-table-con">
                                <el-table
                                    :data="tableData.data"
                                    style="width: 100%"
                                    row-key="id"
                                    border
                                    stripe
                                    ref="table"
                                    highlight-current-row
                                    @sort-change="sortChange"
                                    :height="tableHeight">
                                <el-table-column
                                        fixed
                                        prop="name"
                                        label="分类名称"
                                        min-width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="create_time"
                                        label="创建时间"
                                        min-width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        prop="update_time"
                                        label="修改时间"
                                        min-width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        fixed="right"
                                        label="操作"
                                        width="120">
                                    <template slot-scope="scope">
                                        <el-button @click="handleTableEditOpen(scope.row)" type="text" :size="size">编辑</el-button>
                                        <el-button @click="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
							<!-- <el-pagination
								background
								ref="pagination"
								@current-change="handleCurrentChange"
								:current-page="tableData.page | number"
								:page-size="tableData.pagesize | number"
								layout="total, prev, pager, next"
								:total="tableData.total | number">
							</el-pagination> -->
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    <!--添加分类-->
    <el-dialog
      title="添加分类"
      :visible.sync="addFormVisiable"
      width="40%">
    	  <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px">
    		  <div>
    			  <el-form-item label="分类名称" prop="name">
    				<el-input v-model="addForm.name" placeholder="请填写分类名称" clearable></el-input>
    			  </el-form-item>
    		  </div>
    	  </el-form>
    	  <span slot="footer" class="dialog-footer">
    		<el-button type="primary" @click="addFlowtype" :size='size'>提交</el-button>
    		<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
    	  </span>
    </el-dialog>
    <!--编辑分类-->
    <el-dialog
      title="编辑分类"
      :visible.sync="editFormVisiable"
      width="40%">
    	  <el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px">
    		  <div>
    			<el-form-item label="分类名称" prop="name">
    				<el-input v-model="editForm.name" placeholder="请填写分类名称" clearable></el-input>
    			</el-form-item>
    		  </div>
    	  </el-form>
    	  <span slot="footer" class="dialog-footer">
    		<el-button type="primary" @click="editFlowtype" :size='size'>提交</el-button>
    		<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
    	  </span>
    </el-dialog>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
          addFormVisiable: false,
          editFormVisiable: false,
          checkSkVisiable: false,
          activeName: 'first',
          size:'mini',
          searchForm: {
              name: '',
          },
          resetSearch: {
              name: '',
          },
          addForm: {
              name: '',
          },
          editForm: {
              name: '',
          },
          rules: {
              addForm: {
                  'name': [
                      {required: true, message: '请填写分类名称', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的分类名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
              },
              editForm: {
                  'name': [
                      {required: true, message: '请填写分类名称', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的分类名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
              }
          },
          tableData: {
              total: 0,
              pagesize: 100,
              page: 1,
              data: []
          }
      }
  },
  computed: {
      tableHeight: function () {
          return window.innerHeight - 220;
      }
  },
  mounted: function () {
      this.handleSearch(this.searchForm);
  },
  methods: {
		//列表查询
		handleSearch(params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/examine/flowtype/list',param).then(res => {
			   if (res.code == 0) {
				   this.tableData = res.data;		
			   }else{
				   this.$message.error(res.msg);
			   }
			})
		},
		// 执行查询
		doSearch() {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset() {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange(e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
			  order = 'asc';
			} else if (e.order == 'descending') {
			  order = 'desc';
			} else {
			  prop = this.resetSearch.prop;
			  order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange(val) {
			this.handleSearch(this.searchForm, val);
		},
		// 添加菜单弹窗
		addFlowtypeOpen(){
			this.addForm = {
              name: ''
			}
			this.addFormVisiable = true;
		},
		// 添加分类
		addFlowtype() {
		  this.$refs['addForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.post('/admin/examine/flowtype/add',this.addForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '分类添加成功！',
							  type: 'success'
						  });
						  this.addFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
		
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
		  }.bind(this));
		},
		//编辑弹窗
		handleTableEditOpen(row){
			this.$api.get('/admin/examine/flowtype/info',{id:row.id}).then(res => {
				  if (res.code == 0) {
					  this.editForm = res.data
					  this.editFormVisiable = true;
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			})
		},
		//编辑分类
		editFlowtype(){
			this.$refs['editForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.put('/admin/examine/flowtype/edit',this.editForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '分类信息修改成功！',
							  type: 'success'
						  });
						  this.editFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
			}.bind(this));
		},
		//删除
		handleTableDelete(row){
			this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(function() {
			  this.loading = true;
			  this.$api.delete('/admin/examine/flowtype/del', {id:row.id}).then(res => {
				  if (res.code == 0) {
					  var data = this.tableData.data;
					  data.forEach(function (item, index) {
						  if (item.id == row.id) {
							  this.$delete(data, index);
						  } else if (item.children) {
							  item.children.forEach(function (value, key) {
								  if (value.id == row.id) {
									  this.$delete(item.children, key);
								  }
							  }.bind(this));
						  }
					  }.bind(this));
					  this.$message({
						  showClose: true,
						  message: '该分类已成功删除！',
						  type: 'success'
					  });
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			  })
			}.bind(this))
		}
    }
}
</script>